<template>
  <div class="org-tree" v-loading="loading">
    <!-- 搜索框 -->
    <div class="search-box">
      <div class="input-box">
        <el-input
          v-model="searchValue"
          @keyup.enter.native="searchData"
          @input="watchInputValue"
          placeholder="请输入手机号或名称搜索"
          :class="{ 'big': !showAdd }"
        >
          <i slot="suffix" class="el-input__icon el-icon-search" v-if="!searchValue"></i>
          <i slot="suffix" class="el-input__icon el-icon-error" @click="searchClose" v-else></i>
        </el-input>
        <el-button v-if="showAdd" type="primary" class="add-btn" @click="addData">新增</el-button>
      </div>
      <!-- 一级且开通2级机构功能 -->
      <div class="info-box" v-if="accountLevel == 1 && userinfo.isOpenMechanism == 1">标<span>“*”</span>的为未配置费率模板的团队</div>
    </div>
    <div class="search-list" v-if="searchValue && entered" v-loading="searchLoading">
      <!-- 搜索结果 -->
      <div class="result">
        共有
        <span class="total-num">{{ total }}</span> 条搜索结果
      </div>
      <!-- 搜索解果列表 -->
      <div class="search-result">
        <!-- 机构 -->
        <div class="item" v-if="channelData && channelData.length > 0">
          <div class="bar">
            <img class="bar-icon" src="@static/images/orgManage/org.png" />
            <span>机构（{{ channelData.length }}）</span>
          </div>
          <div class="result-content" :class="channelDataFlag && channelData.length > 3 ? '' : 'packUp'">
            <div class="result-list" @click="searchSelect(channel)" v-for="(channel, c) in channelData" :key="c">
              <tooltip class="text-name" :class="{ active: channel.active === true }" :txt-info="channel.deptmantName"></tooltip>
              <tooltip class="text-level" :txt-info="channel.mobile" style="margin-bottom: 5px"></tooltip>
              <tooltip class="text-level" :txt-info="channel.fullPath"></tooltip>
            </div>
          </div>
        </div>
        <div class="line" v-if="channelData && channelData.length > 0"></div>
        <div class="view-more" @click="channelDataFlag = !channelDataFlag" v-if="channelData.length > 3">
          <span>{{ channelDataFlag ? '收起' : '查看更多' }}</span>
          <i style="margin-left: 8px" :class="channelDataFlag ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </div>
        <!-- 员工 -->
        <div class="item" v-if="staffData && staffData.length">
          <div class="bar">
            <img class="bar-icon" src="@static/images/orgManage/staff.png" />
            <span>员工（{{ staffData.length }}）</span>
          </div>
          <div class="result-content" :class="staffDataFlag && staffData.length > 3 ? '' : 'packUp'">
            <div class="result-list" @click="staffSelect(staff)" v-for="(staff, s) in staffData" :key="s">
              <tooltip class="text-name" :class="{ active: staff.active === true }" :txt-info="staff.deptmantName"></tooltip>
              <tooltip class="text-level" :txt-info="staff.mobile" style="margin-bottom: 5px"></tooltip>
              <tooltip class="text-level" :txt-info="staff.fullPath"></tooltip>
            </div>
          </div>
        </div>
        <div class="line" v-if="staffData && staffData.length > 0"></div>
        <div class="view-more" @click="staffDataFlag = !staffDataFlag" v-if="staffData.length > 3">
          <span>{{ staffDataFlag ? '收起' : '查看更多' }}</span>
          <i style="margin-left: 8px" :class="staffDataFlag ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </div>
        <!-- 部门 -->
        <div class="item" v-if="deptData && deptData.length > 0">
          <div class="bar">
            <img class="bar-icon" src="@static/images/orgManage/dept.png" />
            <span>部门（{{ deptData.length }}）</span>
          </div>
          <div class="result-content" :class="deptDataFlag && deptData.length > 3 ? '' : 'packUp'">
            <div class="result-list" @click="deptSelect(dept)" v-for="(dept, d) in deptData" :key="d">
              <tooltip class="text-name" :class="{ active: dept.active === true }" :txt-info="dept.deptmantName"></tooltip>
              <tooltip class="text-level" :txt-info="dept.mobile" style="margin-bottom: 5px"></tooltip>
              <tooltip class="text-level" :txt-info="dept.fullPath"></tooltip>
            </div>
          </div>
        </div>
        <div class="line" v-if="deptData && deptData.length > 0"></div>
        <div class="view-more" @click="deptDataFlag = !deptDataFlag" v-if="deptData.length > 3">
          <span>{{ deptDataFlag ? '收起' : '查看更多' }}</span>
          <i style="margin-left: 8px" :class="deptDataFlag ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </div>
      </div>
    </div>
    <el-tree
      :data="treeData"
      icon-class="icon-tree"
      :indent="0"
      :props="defaultProps"
      ref="orgTreeRef"
      node-key="deptId"
      :highlight-current="true"
      :expand-on-click-node="false"
      :current-node-key="currentNodeKey"
      :default-expand-all="true"
      @node-click="currentSelectedNode"
      v-else
    >
      <div class="custom-tree-node" slot-scope="{ node, data }">
        <!-- <div class="tag" v-if="data.level=='1'">总部</div> -->
        <div class="tag" v-if="data.level == '2' && accountLevel == 1">团队</div>
        <div class="tag" v-if="data.level == '3' && accountLevel == 1">团队</div>
        <span class="xh" v-if="data.level == '2' && accountLevel == 1 && !data.commissonTemplateId">*</span>
        <tooltip class="text-node" :txt-info="node.label"></tooltip>
      </div>
    </el-tree>

    <!-- 新增组织 -->
    <addOrgDialog ref="addOrgDialog"></addOrgDialog>
  </div>
</template>
<script>
import tooltip from '@/components/tooltip.vue';
import addOrgDialog from './addOrgDialog.vue';
export default {
  components: {
    tooltip,
    addOrgDialog
  },
  data: () => ({
    deptDataFlag: false, // 部门的查看更多
    channelDataFlag: false, // 机构的查看更多
    staffDataFlag: false, // 员工查看更多
    searchValue: '', // 搜索关键字
    entered: false, // 是否回车确认搜索
    treeData: [], // 组织树数据
    loading: false, // 数据加载loading
    searchLoading: false, // 页面搜索loading
    defaultProps: {
      children: 'children',
      label: 'deptmantName'
    }, //  el-tree默认参数配置
    total: 0,
    staffData: [], // 员工搜索数据列表
    channelData: [], // 渠道搜索数据列表
    deptData: [], // 部门搜索数据列表
    currentNodeKey: '',
    currentNodeLevel: '',
    userinfo: {},
    accountLevel: '' // 1一级机构，2二级机构，3员工
  }),
  watch: {
    // 通过current-node-key来双向绑定当前节点值，node-key设置当前节点，highlight-current高亮当前节点，
    currentNodeKey: {
      handler(id) {
        if (!this.$refs.orgTreeRef) {
          return;
        }
        this.$nextTick(() => {
          id ? this.$refs.orgTreeRef.setCurrentKey(id) : this.$refs.orgTreeRef.setCurrentKey(null);
          this.$nextTick(() => {
            // 设置了current-node-key后选中的当前树会有is-current这个class，绑定点击事件。实现任意节点回显高亮并触发点击事件
            document.querySelector('.is-current')?.firstChild.click();
          });
        });
      },
      deep: true
      // immediate:true
    }
  },
  computed: {
    showAdd() {
      return this.accountLevel == 1 && this.currentNodeLevel != 3;
    }
  },
  created() {
    const userinfo = this.$tools.getLocal('userinfo');
    this.userinfo = userinfo;
    this.accountLevel = userinfo.level;
    localStorage.removeItem('CURRENTNODEKEY');
    this.init();
    this.$bus.$on('refreshTree', res => {
      this.currentNodeKey = '';
      this.currentNodeLevel = '';
      this.getTree();
    });
  },
  methods: {
    // 初始化
    init() {
      if (this.treeData.length) {
        return;
      }
      this.getTree();
    },
    // 获取组织tree的数据
    getTree() {
      this.loading = true;
      this.$store.commit('SET_ORGLOADING', true);
      this.$http({
        url: '/master/subAccount/getMechanTree',
        type: 'PUT',
        params: {}
      })
        .then(res => {
          // 如果存在当前选中的节点，树刷新后还是选中当前的节点。否则选中一级节点
          if (localStorage.getItem('CURRENTNODEKEY')) {
            this.currentNodeKey = localStorage.getItem('CURRENTNODEKEY');
          } else {
            this.currentNodeKey = res.data.deptId;
          }
          this.loading = false;
          this.$store.commit('SET_ORGLOADING', false);
          this.treeData = [res.data];
          this.$store.commit('SET_TREE', JSON.stringify(res.data));
        })
        .catch(e => {
          this.loading = false;
          this.$store.commit('SET_ORGLOADING', false);
        });
    },
    // 当前选中的节点
    currentSelectedNode(cur, node, el) {
      console.log('当前选中的节点', cur, node, el);
      // 定位当前选中节点，并通过watch触发点击事件
      this.currentNodeKey = cur.deptId;
      this.currentNodeLevel = cur.currentLevel;
      localStorage.setItem('CURRENTNODEKEY', this.currentNodeKey);
      // 存储当前选中的节点层级
      this.$store.commit('SET_CURRENTNODELEVEL', node.currentLevel);
      // 存储当前选中的节点
      this.$store.commit('SET_CURRENTNODE', JSON.stringify(cur));
    },
    // 回车键搜索
    searchData() {
      (this.deptDataFlag = false), // 部门的查看更多
        (this.channelDataFlag = false), // 机构的查看更多
        (this.staffDataFlag = false), // 员工查看更多
        (this.staffData = []);
      this.channelData = [];
      this.deptData = [];
      this.entered = true;
      if (this.searchValue) {
        this.searchLoading = true;
        this.$http({
          url: '/master/mechanDept/queryDeptOrUser',
          type: 'GET',
          params: {
            name: isNaN(Number(this.searchValue)) ? this.searchValue : '',
            mobile: !isNaN(Number(this.searchValue)) ? this.searchValue : ''
          }
        })
          .then(res => {
            this.searchLoading = false;
            res.data.map((item, index) => {
              if (item.level == 1 || item.level == 2) {
                this.channelData.push(item);
              } else if (item.level == 3) {
                this.staffData.push(item);
              } else if (!item.level) {
                this.deptData.push(item);
              }
            });
            this.channelData.forEach(item => {
              this.$set(item, 'active', false);
            });
            this.staffData.forEach(item => {
              this.$set(item, 'active', false);
            });
            this.deptData.forEach(item => {
              this.$set(item, 'active', false);
            });
            this.total = res.data.length;
          })
          .catch(e => {
            this.searchLoading = false;
          });
      }
    },
    // 监听输入的搜索框的值
    watchInputValue(val) {
      // 不存在就不搜索
      if (!val) {
        this.entered = false;
      }
    },
    // 搜索选中员工时
    staffSelect(item) {
      this.channelData.forEach(item => {
        this.$set(item, 'active', false);
      });
      this.staffData.forEach(item => {
        this.$set(item, 'active', false);
      });
      this.deptData.forEach(item => {
        this.$set(item, 'active', false);
      });
      this.currentNodeLevel = item.currentLevel;
      item.active = true;
      this.$store.commit('SET_CURRENTNODE', JSON.stringify(item));
    },
    // 搜索之后选中机构
    searchSelect(item) {
      this.channelData.forEach(item => {
        this.$set(item, 'active', false);
      });
      this.staffData.forEach(item => {
        this.$set(item, 'active', false);
      });
      this.deptData.forEach(item => {
        this.$set(item, 'active', false);
      });
      this.currentNodeLevel = item.currentLevel;
      this.currentNodeKey = item.deptId;
      item.active = true;
      this.$store.commit('SET_CURRENTNODE', JSON.stringify(item));
    },
    // 搜索之后选中部门
    deptSelect(item) {
      this.channelData.forEach(item => {
        this.$set(item, 'active', false);
      });
      this.staffData.forEach(item => {
        this.$set(item, 'active', false);
      });
      this.deptData.forEach(item => {
        this.$set(item, 'active', false);
      });
      this.currentNodeLevel = item.currentLevel;
      this.currentNodeKey = item.deptId;
      item.active = true;
      // 搜索时，二级机构的数据层级是从2算起的，要重置为1算起，否则部门的权限判断会有问题
      // 这里的层级是指的相对于树里数据的层级
      if (this.accountLevel == 2) {
        // 存储部门当前层级
        this.$store.commit('SET_CURRENTNODELEVEL', item.currentLevel * 1 - 1);
      } else {
        this.$store.commit('SET_CURRENTNODELEVEL', item.currentLevel);
      }
      this.$store.commit('SET_CURRENTNODE', JSON.stringify(item));
    },
    // 退出搜索
    searchClose() {
      this.searchValue = '';
      this.entered = false;
      // 清空当前选中的节点，刷新树列表,
      this.currentNodeKey = '';
      this.currentNodeLevel = '';
      // 清空缓存的当前选中的节点
      localStorage.removeItem('CURRENTNODEKEY');
      // 清空vuex，触发监听
      this.$store.commit('SET_CURRENTNODE', '');
      this.getTree();
    },
    // 新增
    addData() {
      this.$refs.addOrgDialog.open({ parentMechanId: this.currentNodeKey });
    }
  }
};
</script>
<style lang="scss" scoped>
@import './organizeTree.scss';
</style>
